import { Component, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteCompleteEvent } from 'primeng/autocomplete';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { Table, TableLazyLoadEvent, TableRowSelectEvent } from 'primeng/table';
import { BehaviorSubject, debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { AgreementsControllerGetAll$Params } from 'src/app/api/fn/agreements/agreements-controller-get-all';
import { AssetManagementControllerGetAll$Params } from 'src/app/api/fn/asset-management/asset-management-controller-get-all';
import { OfficeControllerGetAll$Params } from 'src/app/api/fn/registry-offices/office-controller-get-all';
import {
  AgreementItem,
  AssetManagementItem,
  MaintenanceDeliveryFromAssetManagementReplacementCreateDto,
  RegistryOfficeItem,
  ReplacementAssetManagementCreateDto,
} from 'src/app/api/models';
import {
  AgreementsService,
  AssetManagementService,
  RegistryOfficesService,
} from 'src/app/api/services';
import { manipulateToUTCISOString } from 'src/main';

@Component({
  selector: 'app-modal-replace-asset-management',
  templateUrl: './modal-replace-asset-management.component.html',
  styleUrls: ['./modal-replace-asset-management.component.scss'],
})
export class ModalReplaceAssetManagementComponent {
  @ViewChild('assetTable') assetTable?: Table;

  protected readonly rowsPerPageOptions = [25, 50, 100, 200, 500];
  availableAssetsManagement: AssetManagementItem[] = [];
  autocompleteAgreements$ = new BehaviorSubject<string>('');
  suggestedAgreements: AgreementItem[] = [];
  autocompleteWarehouses$ = new BehaviorSubject<string>('');
  suggestedWarehouses: RegistryOfficeItem[] = [];
  totalRecords = 0;
  pickerType?: string;
  question_title: string;
  selectedAM = new FormControl<AssetManagementItem | null>(null);
  amToReplace?: AssetManagementItem;
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public dialogService: DialogService,
    private amService: AssetManagementService,
    private confirmationService: ConfirmationService,
    private agreementService: AgreementsService,
    private officeService: RegistryOfficesService,
    private messageService: MessageService,
    private router: Router
  ) {
    const chosen = config.data.chosenAddresses;
    this.pickerType = config.data.pickerType;
    this.question_title = config.data.question_title;
    this.amToReplace = config.data.amToReplace;
  }

  frmFilter = new FormGroup({
    related_warehouse: new FormControl<RegistryOfficeItem | undefined>(undefined),
    related_agreement: new FormControl<AgreementItem | undefined>(undefined),
    part_number: new FormControl<string | undefined>(undefined),
    serial_number: new FormControl<string | undefined>(undefined),
    asset_code: new FormControl<string | undefined>(undefined),
    notes: new FormControl<string | undefined>(undefined),
    active: new FormControl<boolean>(true),
    lost: new FormControl<boolean>(false),
    faulty: new FormControl<boolean>(false),
    end_of_warranty_date: new FormControl<[Date, Date] | undefined>(undefined),
    testing_date: new FormControl<[Date, Date] | undefined>(undefined),
  });

  ngOnInit() {
    // this.selectedAM.valueChanges.subscribe(v => {
    //   console.log('Selected AM changed:', v);
    // });

    // autocomplete agreements
    // this.autocompleteAgreements$
    //   .pipe(
    //     debounceTime(300),
    //     distinctUntilChanged(),
    //     switchMap(query => {
    //       if (query) {
    //         let params: AgreementsControllerGetAll$Params = {
    //           limit: 15,
    //           skip: 0,
    //           name: query,
    //           active: true,
    //         };
    //         return this.agreementService.agreementsControllerGetAll(params);
    //       } else {
    //         return of({
    //           data: { list: [] },
    //         });
    //       }
    //     })
    //   )
    //   .subscribe({
    //     next: res => {
    //       this.suggestedAgreements = res.data.list;
    //     },
    //   });
    // // autocomplete magazzini
    // this.autocompleteWarehouses$
    //   .pipe(
    //     debounceTime(300),
    //     distinctUntilChanged(),
    //     switchMap(query => {
    //       if (query) {
    //         let params: OfficeControllerGetAll$Params = {
    //           limit: 15,
    //           skip: 0,
    //           query: query,
    //         };
    //         return this.officeService.officeControllerGetAll(params);
    //       } else {
    //         return of({
    //           data: { list: [] },
    //         });
    //       }
    //     })
    //   )
    //   .subscribe({
    //     next: res => {
    //       this.suggestedWarehouses = res.data.list;
    //     },
    //   });

    this.frmFilter.valueChanges.pipe(debounceTime(300), distinctUntilChanged()).subscribe(v => {
      this.fetchAssetsManagements(this.assetTable?.createLazyLoadMetadata());
    });
  }

  onAssetSelect(event: TableRowSelectEvent) {
    this.selectedAM.setValue(event.data);
  }

  close() {
    this.ref.close();
  }
  save() {
    this.confirmationService.confirm({
      message: `Confermi la sostituzione <strong>definitiva</strong> dell'asset n. <strong>${this.amToReplace?.serial_number}</strong> con l'asset n. <strong>${this.selectedAM.value?.serial_number}</strong> ?`,
      header: 'Attenzione',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sì',
      acceptButtonStyleClass: 'bg-danger',
      rejectButtonStyleClass: 'p-button-outlined',
      accept: () => {
        const body: ReplacementAssetManagementCreateDto = {
          asset_management_to_replace_id: this.amToReplace?.id!,
          replacement_asset_management_id: this.selectedAM?.value?.id!,
        };

        this.amService.assetManagementControllerReplacementAssetManagement({ body }).subscribe({
          next: res => {
            this.router.navigateByUrl('/main/asset');
            this.messageService.add({
              severity: 'success',
              summary: 'Aggiornamento',
              detail: `Sostituzione effettuata.`,
            });
            this.ref.close(true);
          },
        });
      },
    });
  }

  filterAgreements(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteAgreements$.next(query);
  }

  filterWarehouses(event: AutoCompleteCompleteEvent) {
    let query = event.query;
    this.autocompleteWarehouses$.next(query);
  }

  fetchAssetsManagements(event: TableLazyLoadEvent) {
    const frmValue = this.frmFilter.value;
    const end_of_warranty_date_from = frmValue.end_of_warranty_date
      ? manipulateToUTCISOString(frmValue.end_of_warranty_date[0], false)
      : undefined;
    const end_of_warranty_date_to = frmValue.end_of_warranty_date
      ? manipulateToUTCISOString(frmValue.end_of_warranty_date[1], true, true)
      : undefined;

    const testing_date_from = frmValue.testing_date
      ? manipulateToUTCISOString(frmValue.testing_date[0], false)
      : undefined;
    const testing_date_to = frmValue.testing_date
      ? manipulateToUTCISOString(frmValue.testing_date[1], true, true)
      : undefined;

    const params: AssetManagementControllerGetAll$Params = {
      limit: +event.rows!,
      skip: +event.first!,
      part_number: frmValue.part_number ?? undefined,
      serial_number: frmValue.serial_number ?? undefined,
      asset_code: frmValue.asset_code ?? undefined,
      notes: frmValue.notes ?? undefined,
      active: frmValue.active ?? undefined,
      lost: frmValue.lost ?? undefined,
      faulty: frmValue.faulty ?? undefined,
      end_of_warranty_date_from: end_of_warranty_date_from,
      end_of_warranty_date_to: end_of_warranty_date_to,
      testing_date_from: testing_date_from,
      testing_date_to: testing_date_to,
      // related_warehouse_id: frmValue.related_warehouse?.id || undefined,
      show_only_asset_without_warehouse_id: true,
      show_only_asset_with_registry_end_customer_id: true,
      related_agreement_id: this.amToReplace?.related_agreement?.id ?? undefined,
      exclude_id: this.amToReplace?.id!,

      // related_agreement_id: frmValue.related_agreement?.id || undefined,
    };

    this.amService.assetManagementControllerGetAll(params).subscribe({
      next: res => {
        this.availableAssetsManagement = res.data.list;
        this.totalRecords = res.data.count;
      },
    });
  }

  clear(table: Table) {
    this.frmFilter.reset(
      {
        active: true,
      },
      { emitEvent: false }
    );

    table.reset();
  }
}
